import React, { useMemo } from "react";
import { formatAmount } from "../../../model/accounting/formatAmount.js";
import { EntryLike, calculateChanges } from "../../../model/accounting/account/ChangeMap.js";
import { Link } from "../../../../packages/router/Link.js";
import { Column } from "../../../../packages/ui/table/quick/Column.js";
import { AccountChange } from "../../../model/accounting/account/AccountChange.js";
import { FixedTable } from "../../../../packages/ui/table/quick/FixedTable.js";

type Props = {
  entry: EntryLike;
};

/**
 * Renders the block of changes under an entry.
 */
export const ChangesTable = ({ entry }: Props) => {
  const changes = useMemo(() => calculateChanges(entry).asArray(), [entry]);

  const columns: Column<AccountChange>[] = [
    {
      span: 5,
      title: "Konto",
      render: (row) => (
        <Link to={`/account/${row.account.id}`}>
          {row.account.code} ({row.account.name})
        </Link>
      )
    },
    {
      span: 3,
      title: "Pealkiri",
      render: (row) => formatAmount(row.change),
      textAlign: "right"
    }
  ];

  return <FixedTable columns={columns} rows={changes} fontSize="tiny" />;
};
